





























































import Vue, {PropType} from "vue";
import SDSelectBox from "../SDSelectBox.vue";
import { PriceRange } from "../../types/FilterTypes";
import Inbox from "../../../module/Account/view/vue/inbox.vue";
import {Price} from "../../../module/Deals/view/vue/domain/Price";
interface IData {
  isMinimalSelectionActive: boolean,
  isMaximumSelectionActive: boolean,
  parentBottomPosition:number,
  initialX: number,
  touchDownOnCustomThumb: boolean,
  isMinHandler: boolean,
  leftHandleDragValue: number,
  rightHandleDragValue: number
}
interface IMethods {
  onInput ( event : any, getNewFilters: boolean): void,
  setIsMinimalSelectionActive(isActive: boolean): void ,
  setIsMaximumSelectionActive(isActive: boolean): void,
  handleSelectionOptionClick(isMinimal:boolean, selection:any, getNewFilters:boolean): void,
  handleTouchEnd(): void,
  handleCustomThumbTouchDown(event:TouchEvent, isMinHandler:boolean): void,
  moveHandler(clientX:number): void,
  mouseMoveHandler(event:MouseEvent):void,
  touchMoveHandler(event:TouchEvent):void,
  syncTouchOverlayWithHandle():void
}
interface IComputed {
  visualMinValue: number,
  visualMaxValue: number,
  minimalSliderSelectionOptions: Array<any>,
  maximumSliderSelectionOptions: Array<any>,
  isMobile: boolean,
  isDesktop: boolean
  getMobilePixelPercentage:number,
  computedSliderStyles: {progressLeft:number, progressRight:number } ,
  computedSliderStylesAsPercentages: any,
  getPixelDifferenceToJump: number,
  maximumSelectBoxValue: number,
  maxSliderValue: number,
  isDisplayedAsUncapped: boolean,
  maxAllowedMinValue: number,
  maxWhenCrossingMin: { max: number, exceeds_max_cap: boolean }
}
interface IProps {
 priceRange: PriceRange
}

export type PriceSliderEmit = {
  selectedPrices: { min: number, max: number, exceeds_max_cap: boolean },
  getNewFilters: boolean
}

export type SliderValues = {
  selectedMinValue: number,
  selectedMaxValue: number
}
export default Vue.extend<IData,IMethods,IComputed,IProps>({
  name: 'PriceSlider',
  components: {Inbox, SDSelectBox },
  props: {
    priceRange: {
      type: Object as PropType<IProps['priceRange']>,
      required: true
    }
  },
  data() {
    return {
      isMinimalSelectionActive: false,
      isMaximumSelectionActive: false,
      parentBottomPosition:0,
      initialX: 0,
      touchDownOnCustomThumb:false,
      isMinHandler: false,
      leftHandleDragValue:0,
      rightHandleDragValue:0
    }
  },
  methods: {
    onInput ( event : any, getNewFilters: boolean) {
      const target = event.target;
      let selectedPrices = Object.assign({}, this.priceRange.selected);

      // check for preventing handles to cross
      if (target.name === 'min' || target.name === 'min-number') {
        selectedPrices.min = Math.min(parseFloat(target.value), this.maxAllowedMinValue);
      }
      if (target.name === 'max' || target.name === 'max-number') {
        const val = parseFloat(target.value);
        if (val > this.priceRange.selected.min) {
          selectedPrices.max = Math.min(val, this.priceRange.max_value);
          selectedPrices.exceeds_max_cap = this.priceRange.exceeds_max_cap && val > this.priceRange.max_value;
        } else {
          Object.assign(selectedPrices, this.maxWhenCrossingMin);
        }
      }

      const payload = {
        selectedPrices: selectedPrices,
        getNewFilters: getNewFilters
      }
      this.$emit('price-slider-values-changed', payload);
    },
    setIsMinimalSelectionActive(isActive: boolean) {
      this.isMinimalSelectionActive = isActive;
    },
    setIsMaximumSelectionActive(isActive: boolean) {
      this.isMaximumSelectionActive = isActive;
    },
    handleSelectionOptionClick(isMinimal:boolean, selection:any, getNewFilters: boolean = true) {
      //check if selected options is not crossing the other slide, if so set it back to the max value (lowest or highest possible).
      let selectedPrices = Object.assign({}, this.priceRange.selected);
      if(isMinimal) {
        selectedPrices.min = Math.min(selection.key, this.maxAllowedMinValue);
      } else if(selection.key > this.priceRange.max_value) {
        selectedPrices.max = this.priceRange.max_value;
        selectedPrices.exceeds_max_cap = true;
      } else if(selection.key <= this.priceRange.selected.min) {
        Object.assign(selectedPrices, this.maxWhenCrossingMin);
      } else {
        selectedPrices.max = selection.key;
        selectedPrices.exceeds_max_cap = false;
      }
      const payload = {
        selectedPrices: selectedPrices,
        getNewFilters: getNewFilters
      }
      this.$emit('price-slider-values-changed', payload);
    },
    handleTouchEnd() {
      if(this.touchDownOnCustomThumb) {
        let selectedPrices = Object.assign({}, this.priceRange.selected);
        const payload = {
          selectedPrices: selectedPrices,
          getNewFilters: true
        }
        this.$emit('price-slider-values-changed', payload);
        this.touchDownOnCustomThumb = false;
      }
    },
    handleCustomThumbTouchDown(event:TouchEvent, isMinHandler:boolean) {
      this.initialX = Math.floor(event.touches[0].clientX);
      this.isMinHandler = isMinHandler;
      this.touchDownOnCustomThumb = true;
    },
    moveHandler(clientX:number) {
      if(this.touchDownOnCustomThumb) {
        const isRight = clientX - this.initialX >= this.getPixelDifferenceToJump;
        const isLeft = this.initialX - clientX >= this.getPixelDifferenceToJump;
        if(this.isMinHandler) {
          if(isRight) {
            const newValue = this.priceRange.selected.min + (this.priceRange.step_size * Math.floor((clientX - this.initialX) / this.getPixelDifferenceToJump));
            this.handleSelectionOptionClick(true, {key: newValue},false)
          } else if(isLeft) {
            const newValue = this.priceRange.selected.min - (this.priceRange.step_size * Math.floor((this.initialX - clientX) / this.getPixelDifferenceToJump));
            this.handleSelectionOptionClick(true, {key: newValue >= this.priceRange.min_value ? newValue : this.priceRange.min_value},false)
          }

          if(isRight || isLeft) {
            this.initialX = clientX;
          }
        } else {
          if(isRight) {
            const newValue = this.maxSliderValue + (this.priceRange.step_size * Math.floor(( clientX - this.initialX) / this.getPixelDifferenceToJump));
            this.handleSelectionOptionClick(false, {key: newValue <= this.priceRange.max_value ? newValue : (this.priceRange.exceeds_max_cap ? this.priceRange.max_value + 1 : this.priceRange.max_value)}, false)
          } else if(isLeft) {
            const newValue = this.maxSliderValue - (this.priceRange.step_size * Math.floor(( this.initialX - clientX) / this.getPixelDifferenceToJump));
            if(this.priceRange.selected.max - this.priceRange.step_size !== this.priceRange.selected.min) {
              this.handleSelectionOptionClick(false, {key: newValue},false)
            }
          }

          if(isRight || isLeft) {
            this.initialX = clientX;
          }
        }
      }
    },
    syncTouchOverlayWithHandle() {
      if(!this.isDesktop && this.$refs.minThumbOverlay && this.$refs.maxThumbOverlay) {
        (this.$refs.minThumbOverlay as HTMLElement).style.left = `calc(${this.getMobilePixelPercentage}px * ${this.computedSliderStyles.progressLeft})`;
        (this.$refs.maxThumbOverlay as HTMLElement).style.right = `calc(${this.getMobilePixelPercentage}px * ${this.computedSliderStyles.progressRight})`;
      }
    },
    mouseMoveHandler(event) {
      this.moveHandler(event.clientX);
    },
    touchMoveHandler(event) {
      this.moveHandler(Math.floor(event.touches[0].clientX));
    }
  },
  computed: {
    // true once both the category and the current selection agree the range is unbounded on top ("400+")
    isDisplayedAsUncapped(): boolean {
      return this.priceRange.selected.exceeds_max_cap && this.priceRange.exceeds_max_cap;
    },
    maximumSelectBoxValue(): number {
      return this.isDisplayedAsUncapped ? this.priceRange.max_value + 1 : this.visualMaxValue;
    },
    maxSliderValue(): number {
      return this.isDisplayedAsUncapped ? this.priceRange.max_value + this.priceRange.step_size : this.visualMaxValue;
    },
    visualMinValue(): number {
      return (this.priceRange.selected.min ?? this.priceRange.min_value) + this.priceRange.step_size;
    },
    visualMaxValue(): number {
      if (this.isDisplayedAsUncapped) {
        return this.priceRange.max_value;
      }
      const max = this.priceRange.selected.max ?? this.priceRange.max_value;
      return max > this.priceRange.max_value ? this.priceRange.max_value : max;
    },
    // min may only reach max_value once max itself is uncapped ("400+"); otherwise it must stay one step below max
    maxAllowedMinValue(): number {
      return this.isDisplayedAsUncapped
        ? this.visualMaxValue
        : this.visualMaxValue - this.priceRange.step_size;
    },
    // where max lands when dragged onto/past min: stays uncapped if that's the only value left above min, otherwise sits one step above it
    maxWhenCrossingMin(): { max: number, exceeds_max_cap: boolean } {
      const canStayUncapped = this.priceRange.exceeds_max_cap && this.visualMinValue > this.priceRange.max_value;
      return canStayUncapped
        ? { max: this.priceRange.max_value, exceeds_max_cap: true }
        : { max: this.visualMinValue, exceeds_max_cap: false };
    },
    minimalSliderSelectionOptions(): Array<any> {
      let numberArray = [];
      for(let number = this.priceRange.min_value; number <= this.maxAllowedMinValue; number += this.priceRange.step_size) {
        let price = Price.create( { amount: number, currency: { code: this.priceRange.currency.code } } );
        numberArray.push({key: number, value: price.render( null, true) });
      }
      return numberArray;
    },
    maximumSliderSelectionOptions(): Array<any> {
      let numberArray = [];
      for(let number = this.visualMinValue; number <= this.priceRange.max_value; number += this.priceRange.step_size) {
        let price = Price.create( { amount: number, currency: { code: this.priceRange.currency.code } } );
        const canExceedMaxCap = number === this.priceRange.max_value && this.priceRange.exceeds_max_cap;
        numberArray.push({key: number, value: `${price.render( null, true)}` });
        if(canExceedMaxCap) {
          numberArray.push({key: number + 1, value: `${price.renderAsMaxPrice()}` });
        }
      }
      if (numberArray.length === 0 && this.priceRange.exceeds_max_cap) {
        let price = Price.create( { amount: this.priceRange.max_value, currency: { code: this.priceRange.currency.code } } );
        numberArray.push({key: this.priceRange.max_value + 1, value: `${price.renderAsMaxPrice()}` });
      }
      return numberArray;
    },
    getMobilePixelPercentage():number {
      //40 because the inputs are 20px smaller and you want to keep half the width of the overlay as distance from the end to the border. so it becomes 40px
      return ((this.$refs.slider as HTMLElement).clientWidth - 40) / 100;
    },
    isMobile(): boolean {
      return sdViewport.isMobile();
    },
    isDesktop(): boolean {
      return sdViewport.isDesktop();
    },
    computedSliderStyles() {
      const selectedMin = this.priceRange.selected.min ?? this.priceRange.min_value;
      return {
        progressLeft: Math.round(((selectedMin - this.priceRange.min_value) / (this.priceRange.max_value - this.priceRange.min_value)) * 100),
        progressRight: 100 - Math.round(((this.visualMaxValue - this.priceRange.min_value) / (this.priceRange.max_value - this.priceRange.min_value)) * 100)
      }
    },
    getPixelDifferenceToJump(): number {
      return (this.priceRange.step_size / this.priceRange.max_value) * ((this.$refs.slider as HTMLElement).clientWidth - (this.isMobile ? 100 : 80));
    },
    computedSliderStylesAsPercentages() {
      if(!this.isDesktop) {
        this.syncTouchOverlayWithHandle();
      }
      return {
        '--progressLeft': this.computedSliderStyles.progressLeft + '%',
        '--progressRight': this.computedSliderStyles.progressRight + '%'
      }
    }
  },
  async mounted() {
    document.addEventListener('mouseup', this.handleTouchEnd);
    document.addEventListener('mousemove', this.mouseMoveHandler);
    document.addEventListener('touchmove', this.touchMoveHandler);
    this.parentBottomPosition = document.getElementsByClassName('drawer-content')[0].getBoundingClientRect().bottom;
  },
  beforeDestroy() {
    document.removeEventListener('mouseup', this.handleTouchEnd);
    document.removeEventListener('mousemove', this.mouseMoveHandler);
    document.removeEventListener('touchmove', this.touchMoveHandler);
  }
});
